import { defineComponent, openBlock, createElementBlock, createElementVNode, toDisplayString, normalizeStyle, createTextVNode } from "vue";
const _hoisted_1 = {
  class: "rating-snapshot__star-rating"
};
const _hoisted_2 = {
  class: "ratings-snapshot__container"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductReviewsRatingSnapshot",
  props: {
    rating: {},
    percentage: {},
    count: {}
  },
  emits: ["metricsClick", "productRatingFilterClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    function onSnapshotClick() {
      if (typeof window !== "undefined") window.location.href = "#reviews-filters";
      emit("productRatingFilterClick", props.rating);
      emit("metricsClick", {
        linkName: `reviews_ratings bar_${props.rating}`
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", {
        class: "ratings-snapshot",
        "data-ui": "ratings-snapshot",
        onClick: onSnapshotClick
      }, [createElementVNode("span", _hoisted_1, toDisplayString(_ctx.rating) + " stars", 1), createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = createElementVNode("div", {
        class: "ratings-snapshot__snapshot-bg",
        "data-ui": "snapshot-bg"
      }, null, -1)), createElementVNode("div", {
        class: "ratings-snapshot__snapshot",
        "data-ui": "snapshot-bar",
        style: normalizeStyle({
          "width": `${_ctx.percentage}%`
        })
      }, null, 4)]), createTextVNode(" " + toDisplayString(_ctx.count), 1)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductReviewsRatingSnapshot2.mjs.map
